import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

import customVertexShader from './shaders/experience1/vertex.glsl'
import customFragmentShader from './shaders/experience1/fragment.glsl'

import * as dat from 'dat.gui'
import Stats from 'stats.js'

// Dat GUI
const gui = new dat.GUI();

// Stats
const stats = new Stats()
stats.showPanel(0)
document.body.appendChild(stats.dom)

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
// const axeHelper = new THREE.AxesHelper(1)
// scene.add(axeHelper)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const texture = textureLoader.load('textures/head.png')

texture.generateMipmaps = false
texture.minFilter = THREE.NearestFilter

// Fog
const fog = new THREE.Fog('#000000', 1, 7)
scene.fog = fog


//Mouse
const mouse = new THREE.Vector2()
window.addEventListener('mousemove', (e) =>
{
    mouse.x = e.clientX / sizes.width * 2 - 1
    mouse.y = - (e.clientY / sizes.height) * 2 + 1

})

// Raycaster
const raycaster = new THREE.Raycaster()


// Plane
// Geometry
const geometry = new THREE.PlaneBufferGeometry(6, 6, 200, 200)
geometry.needsUpdate = true
geometry.verticesNeedUpdate = true

// Material
const material = new THREE.ShaderMaterial({ 
    // wireframe: true,
    uniforms: {
        u_shapePosition: {value: new THREE.Vector3()},
        u_uvPosition: {value: new THREE.Vector2()},
        u_texture: { value: texture },
        u_ghostSize: {value: 150.0},
        u_ghostTexturePosition: {value: new THREE.Vector2(0.853, 1.72)},
        u_time: {value: 0},

        fogColor:    { type: "c", value: scene.fog.color },
    	fogNear:     { type: "f", value: scene.fog.near },
    	fogFar:      { type: "f", value: scene.fog.far },

        u_ghostElevation: { value: 0.15 },
        u_ghostFrequency: { value: 3 },
        u_ghostSpeed: { value: 0.2 },
        u_ghostIterations: { value: 4 }
    },
    vertexShader: customVertexShader,
    fragmentShader: customFragmentShader,
    fog: true
 })

gui.add(material.uniforms.u_ghostElevation, 'value').min(0).max(1).step(0.001).name('Elevation')
gui.add(material.uniforms.u_ghostFrequency, 'value').min(0).max(30).step(0.001).name('Frequency')
gui.add(material.uniforms.u_ghostSpeed, 'value').min(0).max(4).step(0.001).name('Speed')
gui.add(material.uniforms.u_ghostIterations, 'value').min(0).max(5).step(1).name('Iterations')


 // Mesh
const mesh = new THREE.Mesh(geometry, material)
mesh.rotation.x = - Math.PI * 0.5

scene.add(mesh)


// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 3
camera.position.y = 1
camera.position.x = 0
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor('#000000')

// Animate
const clock = new THREE.Clock()

const tick = () =>
{

    stats.begin()
    const elapsedTime = clock.getElapsedTime()

    // Update raycaster
    raycaster.setFromCamera(mouse, camera)
    const intersect = raycaster.intersectObject(mesh)

    if(intersect.length)
    {
        material.uniforms.u_shapePosition.value = intersect[0].point
        material.uniforms.u_uvPosition.value = intersect[0].uv
    }

    // Update u_time
    material.uniforms.u_time.value = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

    stats.end()
}

tick()